<template>
  <div class="hello">
    <nav
      class="navbar navbar-expand-sm fixed-top navbar-light bg-white shadow-sm py-3"
    >
      <button
        class="navbar-toggler float-right"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo03"
        aria-controls="navbarTogglerDemo03"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <router-link to="/">
        <img
          class="navbar-brand ml-2 logo-size"
          src="../assets/kovatek/kovatek-logo.png"
          alt="Kovatek"
        />
      </router-link>

      <div
        class="collapse navbar-collapse justify-content-end m-auto"
        id="navbarTogglerDemo03"
      >
        <ul class="navbar-nav mx-lg-5 pr-4 mt-lg-0">
          <li class="nav-item mt-2">
            <router-link class="kova-text" to="/">
              <a class="mx-3 my-2 my-sm-0" style="font-size: 14px;">
                Skip All
                <span class="sr-only">(current)</span>
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    msg: String
  },
  data() {
    return {
      collapsed: false
    };
  },
  methods: {
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-size {
  height: 35px;
  width: 125px;
}
ova-text {
  color: #20409a;
  font-size: 16px;
  font-weight: bold;
}
.kova-text:hover {
  color: #06216d;
  /* #031547; */
}
.nav-link {
  font-size: 12px;
}
</style>
